import React, { useEffect, useState } from "react";
import AppointmentCard from "../../components/Appointment/AppointmentCard";
import Button from "../../components/Button/Button";
import TopBar from "../../components/TopBar";
import doctorPics from "../../assets/clinic.jpg";
import { Link, useNavigate } from "react-router-dom";
import BottomNav from "../../components/BottomNav";
import { useSelector } from "react-redux";
import Loading from "../../components/Loading";
import { check_token } from "../../utils";

export default function PastAppointment() {
    const store = useSelector(state => state.getAppointmentAction);
    // const dispatch = useDispatch();
    const navigate = useNavigate();
    const data = store.data?.data;
    const [pastApointments, setPastAppointments] = useState([]);

    useEffect(() => {
      check_token()
        setPastAppointments(data?.past);
    }, [])
    return (
        <div className="min-h-screen bg-gray-50">
            <TopBar title={"Appointment"} url={'/homedashboard'} />
            
            {/* Tab Navigation */}
            <div className="bg-white shadow-sm border-b border-gray-100 px-4 py-4">
                <div className="flex justify-center space-x-4">
                    <Link to={'/appointment'} className="flex-1">
                        <Button 
                            width={"full"} 
                            text={"Upcoming"} 
                            textColor={"text-gray-600"}
                            bg={"bg-gray-100"}
                        />
                    </Link>
                    <Link to={'/appointment-past'} className="flex-1">
                        <Button
                            width={"full"}
                            text={"Past"}
                            textColor={"text-white"}
                            bg={"bg-primary100"}
                        />
                    </Link>
                </div>
            </div>

            {/* Content Area with proper bottom padding */}
            <div className="pb-24 pt-4">
                {store?.loading ? (
                    <Loading />
                ) : pastApointments?.length > 0 ? (
                    <div className="space-y-2">
                        {pastApointments.map((item, index) => (
                            <AppointmentCard
                                key={index}
                                pics={doctorPics}
                                name={item.clinic_name || "Clinic"}
                                post={"Clinic"}
                                date={item.appt_date}
                                time={item.appt_time}
                                mode={item.appt_type}
                                status="completed"
                            />
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center py-16">
                        <div className="text-center">
                            <div className="w-24 h-24 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                                <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">No Past Appointments</h3>
                            <p className="text-gray-500 mb-6">You don't have any past appointments to display.</p>
                                    <Link to="/first-appointment">
                                <Button
                                    text="Book Your First Appointment"
                                    bg="bg-primary100"
                                            textColor="text-white"
                                            width={"full"}
                                />
                            </Link>
                        </div>
                    </div>
                )}
            </div>

            <BottomNav color1={'text-primary100'} />
        </div>
    );
}
